import { render } from "./OrderExpensesIndexPage.vue?vue&type=template&id=76bd631e"
import script from "./OrderExpensesIndexPage.vue?vue&type=script&lang=js"
export * from "./OrderExpensesIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__